<script lang="ts">import { getVerbiageKey } from "./utils";
import { Button } from "@infinitro/button";
import { cfgBrandTitle, stateUi } from "@infinitro/config";
import { Container } from "@infinitro/container";
import { t, Verbiage } from "@infinitro/content";
import { isMobile, loggedIn, ModalDialog, pushModal } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
import assets from "./assets";
import RoyaltyBanner from "./parts/become-royalty-banner.svelte";
import Faqs from "./parts/faqs.svelte";
import Steps from "./parts/steps.svelte";
import VipBenefits from "./parts/vip-benefits.svelte";
import VipClub from "./parts/vip-club.svelte";
import VipRankRewardsAlternative from "./parts/vip-rank-rewards-alternative.svelte";
import VipRankRewards from "./parts/vip-rank-rewards.svelte";
import VipTestimonials from "./parts/vip-testimonials.svelte";
/* assets */
const GoldCoin = assets.coin;
const GoldCoins = assets.coins;
const Illustration = assets.background;
$: heroCardOpacity = $stateUi.vip.heroCardOpacity ?? .9;
$: useSummaryRewardsTable = $stateUi.vip.rewardsTableLayout === "summary";
$: useSummaryRewardsTable2 = $stateUi.vip.rewardsTableLayout === "summary2";
</script>

<div class="main">
	{#if GoldCoin && GoldCoins}
		<img src={GoldCoin} alt={$t(Verbiage.gold_coin_single_alt, 'alts')} class="gold-coin" />
		<img src={GoldCoins} alt={$t(Verbiage.gold_coins_alt, 'alts')} class="gold-coins" />
	{/if}
	<img
		src={Illustration}
		alt={$t(Verbiage.section_illustration_alt, 'alts')}
		class="illustration"
	/>
	<Container>
		<div class="main-card-container">
			<div class="card">
				{#if !$loggedIn}
					<InfoCard width={$isMobile ? '92vw' : '384px'} highlight={true} opacity={heroCardOpacity}>
						<div class="main-card-content">
							<Text type="title" titleSize="h5" textAlign="center">
								{$t(Verbiage[getVerbiageKey('more_text')])}
								<span class="highlight">{$t(Verbiage[getVerbiageKey('vip_club_text')])}</span>
								{$t(Verbiage[getVerbiageKey('rewards_and_cashback_description')])}
							</Text>
							<Text type="body" bodySize="large" textColor="gray" textAlign="center">
								{$t(Verbiage[getVerbiageKey('welcome_message')])}
							</Text>
							<Button
								text={$t(Verbiage[getVerbiageKey('sign_up_text')])}
								fullWidth
								onClick={() => pushModal(ModalDialog.Auth, { tab: 'signup' })}
							/>
						</div>
					</InfoCard>
				{:else}
					<InfoCard width={$isMobile ? '92vw' : '384px'} highlight={true} opacity={heroCardOpacity}>
						<div class="main-card-content">
							<Text type="title" titleSize="h5" textAlign="center">
								{$t(Verbiage[getVerbiageKey('raise_your_game_and_stay')])}
							</Text>
							<Text type="title" titleSize="h4" textAlign="center" textColor="primary">
								{$t(Verbiage[getVerbiageKey('with_rewards')])}
							</Text>
							<Text type="body" bodySize="large" textColor="gray" textAlign="center">
								{$t(Verbiage.welcome_to_the_pinnacle, 'global', {
									BRAND: cfgBrandTitle()?.toUpperCase()
								})}
							</Text>
						</div>
					</InfoCard>
				{/if}
			</div>
		</div>
	</Container>
</div>
<Container>
	<div class="sections">
		{#if !$loggedIn}
			<div class="steps">
				<Steps />
			</div>
		{/if}
		<VipBenefits />
		{#if !$loggedIn}
			<VipClub />
		{/if}

		{#if useSummaryRewardsTable || useSummaryRewardsTable2}
			<VipRankRewardsAlternative />
		{/if}

		<VipTestimonials />

		{#if !(useSummaryRewardsTable || useSummaryRewardsTable2)}
			<VipRankRewards />
		{/if}
		<Faqs />

		{#if !$loggedIn}
			<RoyaltyBanner />
		{/if}
	</div>
</Container>

<style>
	.main {
		position: relative;
		display: flex;
		height: 600px;
		width: 100%;
		flex-direction: column;
		align-items: center;
		gap: 1rem;
		overflow: hidden;
		text-align: center;
}

	@media (min-width: 1536px) {
		.main {
				height: 900px;
		}
	}

	.main-card-container {
		position: relative;
		height: 100%;
		width: 100%;
}

	.card {
		position: absolute;
		left: 50%;
		top: 60px;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

	@media (min-width: 1024px) {
		.card {
				left: 0px;
				top: 160px;
				--tw-translate-x: 0px;
				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
		}
	}

	.main-card-content {
		display: flex;
		flex-direction: column;
		gap: 0.75rem;
}

	.illustration {
		width: calc(100% + 7px);
		position: absolute;
		top: 0px;
		left: 49%;
		height: 600px;
		width: auto;
		max-width: none;
		--tw-translate-x: -50%;
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
	}

	@media (min-width: 1024px) {
		.illustration {
				height: auto;
		}
	}
	@media (min-width: 1280px) {
		.illustration {
				left: -7px;
				width: 100%;
				transform: none;
		}
	}

	.gold-coins {
		position: absolute;
		top: 190px;
		right: 40px;
		z-index: 20;
		display: none;
		width: 377px;
}

	@media (min-width: 1024px) {
		.gold-coins {
				display: block;
		}
	}

	.gold-coin {
		position: absolute;
		top: 220px;
		left: -70px;
		z-index: 20;
		display: none;
		width: 120px;
}

	@media (min-width: 1024px) {
		.gold-coin {
				display: block;
		}
	}
	@media (min-width: 1280px) {
		.gold-coin {
				left: -50px;
		}
	}
	@media (min-width: 1536px) {
		.gold-coin {
				left: -40px;
		}
	}

	.highlight {
		color: var(--color-primary-500);
}

	.sections {
		display: flex;
		width: 100%;
		flex-direction: column;
		gap: 6rem;
}

	.steps {
		margin-top: 3rem;
		overflow: hidden;
	}
</style>
